module.exports = "a {\n  text-decoration: underline;\n  color: blue;\n  cursor: pointer;\n}\n"